import React from 'react'
import '../app/Spinner.css'
const Spinner = () => {

  return (
    <div className="centerLoader">
      <div
        tabIndex="0"
        role="progressbar"
        aria-valuetext="Loading…"
        className="cb-loader cb-loader-blue cb-loader-lg"
      />
    </div>
  )
}

export default Spinner
